import { useContext } from "react";
import { SSOContext } from "../../contexts/SSOContext";


const useAuth = () => {
  const context = useContext(SSOContext);
 

  if (!context)
    throw new Error("AuthContext must be placed within AuthProvider");

  
  return context;
};

export default useAuth;
